import { Component, OnInit } from '@angular/core';
import { Menu } from 'src/app/module/menus/menu.module';
import { NbMenuService } from '@nebular/theme';
import { NbMenuItem } from "@nebular/theme";
import { NbSidebarService } from '@nebular/theme';
import {Router} from '@angular/router';
import { MainService } from '../../services/main.service';
import * as _ from 'lodash';
import {FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  logueado = false;
  public usuarioActivo: any;
  public name = [];
  public lastname = [];  
  myGroup;

  
  //public usuarioActivo = { nombre: 'Administrador', foto: '/assets/img/usuario_plataforma.png'};
  items = null;
  constructor(
    private menuService: NbMenuService,
      private sidebarService: NbSidebarService,
      public router: Router,
      public mainService: MainService,
  ) {
    this.items = Menu;
    this.usuarioActivo = JSON.parse(localStorage.getItem('userOcelote'));
  }
  empresas_usuario = [];
  empresas_grupo = [];
  predios_empresa = [];
  filtroGEP = {
    selectedGrupo: [],
    selectedEmpresas: [],
    selectedPredios: []
  };
  empresas = null;
  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Seleccione todos',
    unSelectAllText: 'Deseleccione todos',
    placeholder:"seleccione",
    itemsShowLimit: 1,
    allowSearchFilter: false
  };


  ngOnInit() {
    
    this.myGroup = new FormGroup({
      tipo: new FormControl()
    });
    
    this.mainService.get('tadmEmpresa/').subscribe({ next: (empresas) => {
      this.empresas = empresas;
      empresas.forEach(empresa => {
        if(empresa.cod_empresa == this.usuarioActivo.id_empresa){
          this.empresas_grupo.push(
            {item_id: empresa.cod_empresa,
              item_text: empresa.label
            });
        }
      });

      if(this.empresas_grupo.length == 1){
        this.filtroGEP.selectedGrupo = this.empresas_grupo;
        setTimeout(() => {
          this.onItemSelect(this.empresas_grupo[0], 'Grupo');
        }, 500);
      }

      setTimeout(() => {
        this.onSelectAll(this.empresas_usuario, 'Empresa')
      }, 1000);
      
    }});
  }

  toggle() {
    this.sidebarService.toggle(true, 'menu-sidebar');

    return false;
  }

  inicio() {
    this.router.navigate(['dashboard/home']);
  }

  salir() {
    this.router.navigate(['login']);
  }

  onItemSelect(e, type){

    let filtered = this.empresas
    
    if(type == 'Grupo'){
      var ids = this.filtroGEP.selectedGrupo.map( g => g.item_id);
      this.empresas_usuario = []
      filtered = this.empresas.filter( 
      empresa => empresa.tipo == 'Empresa'  && ids.includes(empresa.padre));

      filtered.map( empresa => { 
        const item =  {item_id: empresa.cod_empresa, item_text: empresa.label}
        this.empresas_usuario.push(item);
      })
      
    }

    if(type == 'Empresa'){
      var ids = this.filtroGEP.selectedEmpresas.map( g => g.item_id);
      filtered = this.empresas.filter( 
      empresa => empresa.tipo == 'Predio' && ids.includes(empresa.padre));
      this.predios_empresa = []
      filtered.map( empresa => { 
        const item = {item_id: empresa.cod_empresa, item_text: empresa.label}
        this.predios_empresa.push(item)
      })
    }
    this.cambioEnFiltro();
  }

  onSelectAll(e, type){
    console.debug(e)
    let filtered = this.empresas
    if(type == 'Grupo'){
      this.empresas_usuario = []
      this.filtroGEP.selectedGrupo = e;
      var ids = this.filtroGEP.selectedGrupo.map( g => g.item_id);
      filtered = this.empresas.filter( 
      empresa => empresa.tipo == 'Empresa'  && ids.includes(empresa.padre));

      filtered.map( empresa => { 
        const item =  {item_id: empresa.cod_empresa, item_text: empresa.label}
        this.empresas_usuario.push(item);
      })
      
    }

    if(type == 'Empresa'){
      this.predios_empresa = []
      this.filtroGEP.selectedEmpresas = e;
      var ids = this.filtroGEP.selectedEmpresas.map( g => g.item_id);
      filtered = this.empresas.filter( 
      empresa => empresa.tipo == 'Predio' && ids.includes(empresa.padre));

      filtered.map( empresa => { 
        const item = {item_id: empresa.cod_empresa, item_text: empresa.label}
        this.predios_empresa.push(item)
      })
    }

    if(type == 'Predio'){
      this.filtroGEP.selectedPredios = e;
    }
    this.cambioEnFiltro();
  }

  onDeSelect(e, type){
    let filtered = this.empresas
    if(type == 'Grupo'){
      this.empresas_usuario = []
      if(e.length == 0){
        this.filtroGEP.selectedEmpresas = []
      }
      var ids = this.filtroGEP.selectedGrupo.map( g => g.item_id);
      filtered = this.empresas.filter( 
      empresa => empresa.tipo == 'Empresa'  && ids.includes(empresa.padre));

      filtered.map( empresa => { 
        const item =  {item_id: empresa.cod_empresa, item_text: empresa.label}
        this.empresas_usuario.push(item);
      }) 
    }

    if(type == 'Empresa'){
      this.predios_empresa = []
      if(e.length == 0){
        this.filtroGEP.selectedEmpresas = []
      }
      var ids = this.filtroGEP.selectedEmpresas.map( g => g.item_id);
      filtered = this.empresas.filter( 
      empresa => empresa.tipo == 'Predio' && ids.includes(empresa.padre));

      filtered.map( empresa => { 
        const item = {item_id: empresa.cod_empresa, item_text: empresa.label}
        this.predios_empresa.push(item)
      })
    }

    if(type='Predio'){
      if(e.length == 0){
        this.filtroGEP.selectedPredios = []
      }
    }
    this.cambioEnFiltro();
  }

  cambioEnFiltro(){
    this.mainService.updateFiltro(this.filtroGEP)
  }

}
